import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
function Home() {
  return (
    <div className="mt-2">
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faHouse} fontSize={128} className='mb-5 text-danger'/>
            <h2>milesoft</h2>
            <p className='text-red'>Transforming ideas into reality.</p>
        </div>
        <div className='container'>
          <div className='card bg-light p-3'>
            <div className='card-body text-center'>
              <p>With expert developers and cutting-edge technology, we create bespoke software solutions tailored to your unique needs. Let's revolutionize your world with the power of software.</p>
              <a href='/about' className='btn btn-primary btn-danger m-2' role='button'>Learn more</a>
            </div>
          </div>
        </div>
        <div className='container'>&nbsp;</div>
    </div>
  )
}

export default Home